export default __webpack_public_path__ + "static/media/SurfaceStudio.ecb9a634.svg";